export interface ISpecCategories {
  name: string;
  FIXMLFileName: string;
  componentType: string;
  section?: string;
  added?: string;
  addedEP?: string;
  includeFile?: string;
  description?: string;
}
export const CATEGORIES: ISpecCategories[] = [
  {
    FIXMLFileName: 'session',
    section: 'Session',
    componentType: 'Message',
    name: 'Session',
  },
  {
    FIXMLFileName: 'indications',
    section: 'PreTrade',
    includeFile: 'components',
    componentType: 'Message',
    name: 'Indication',
  },
  {
    FIXMLFileName: 'order',
    section: 'Trade',
    includeFile: 'components',
    componentType: 'Message',
    name: 'SingleGeneralOrderHandling',
  },
  {
    FIXMLFileName: 'newsevents',
    section: 'PreTrade',
    includeFile: 'components',
    componentType: 'Message',
    name: 'EventCommunication',
  },
  {
    FIXMLFileName: 'listorders',
    section: 'Trade',
    includeFile: 'components',
    componentType: 'Message',
    name: 'ProgramTrading',
  },
  {
    FIXMLFileName: 'ordermasshandling',
    section: 'Trade',
    includeFile: 'components',
    componentType: 'Message',
    name: 'OrderMassHandling',
  },
  {
    FIXMLFileName: 'allocation',
    section: 'PostTrade',
    includeFile: 'components',
    componentType: 'Message',
    name: 'Allocation',
  },
  {
    FIXMLFileName: 'quotation',
    section: 'PreTrade',
    includeFile: 'components',
    componentType: 'Message',
    name: 'QuotationNegotiation',
  },
  {
    FIXMLFileName: 'settlement',
    section: 'PostTrade',
    includeFile: 'components',
    componentType: 'Message',
    name: 'SettlementInstruction',
  },
  {
    FIXMLFileName: 'marketdata',
    section: 'PreTrade',
    includeFile: 'components',
    componentType: 'Message',
    name: 'MarketData',
  },
  {
    FIXMLFileName: 'components',
    includeFile: 'fields',
    componentType: 'Message',
    name: 'Common',
  },
  {
    FIXMLFileName: 'registration',
    section: 'PostTrade',
    includeFile: 'components',
    componentType: 'Message',
    name: 'RegistrationInstruction',
  },
  {
    FIXMLFileName: 'crossorders',
    section: 'Trade',
    includeFile: 'components',
    componentType: 'Message',
    name: 'CrossOrders',
  },
  {
    FIXMLFileName: 'multilegorders',
    section: 'Trade',
    includeFile: 'components',
    componentType: 'Message',
    name: 'MultilegOrders',
  },
  {
    FIXMLFileName: 'tradecapture',
    section: 'PostTrade',
    includeFile: 'components',
    componentType: 'Message',
    name: 'TradeCapture',
  },
  {
    FIXMLFileName: 'confirmation',
    section: 'PostTrade',
    includeFile: 'components',
    componentType: 'Message',
    name: 'Confirmation',
  },
  {
    FIXMLFileName: 'positions',
    section: 'PostTrade',
    includeFile: 'components',
    componentType: 'Message',
    name: 'PositionMaintenance',
  },
  {
    FIXMLFileName: 'collateral',
    section: 'PostTrade',
    includeFile: 'components',
    componentType: 'Message',
    name: 'CollateralManagement',
  },
  {
    FIXMLFileName: 'application',
    section: 'Infrastructure',
    includeFile: 'components',
    componentType: 'Message',
    name: 'Application',
  },
  {
    FIXMLFileName: 'businessreject',
    section: 'Infrastructure',
    includeFile: 'components',
    componentType: 'Message',
    name: 'BusinessReject',
  },
  {
    FIXMLFileName: 'network',
    section: 'Infrastructure',
    includeFile: 'components',
    componentType: 'Message',
    name: 'Network',
  },
  {
    FIXMLFileName: 'usermanagement',
    section: 'Infrastructure',
    includeFile: 'components',
    componentType: 'Message',
    name: 'UserManagement',
  },
  {
    FIXMLFileName: 'fields',
    componentType: 'Field',
    name: 'Fields',
  },
  {
    FIXMLFileName: 'fields',
    componentType: 'Field',
    name: 'ImplFields',
  },
  {
    FIXMLFileName: 'marketstructure',
    includeFile: 'components',
    componentType: 'Message',
    addedEP: '97',
    section: 'PreTrade',
    added: 'FIX.5.0SP1',
    name: 'MarketStructureReferenceData',
  },
  {
    FIXMLFileName: 'securitiesreference',
    includeFile: 'components',
    componentType: 'Message',
    addedEP: '97',
    section: 'PreTrade',
    added: 'FIX.5.0SP1',
    name: 'SecuritiesReferenceData',
  },
  {
    FIXMLFileName: 'marginrequirement',
    includeFile: 'components',
    componentType: 'Message',
    addedEP: '102',
    section: 'PostTrade',
    added: 'FIX.5.0SP2',
    name: 'MarginRequirementManagement',
  },
  {
    FIXMLFileName: 'partiesreference',
    includeFile: 'components',
    componentType: 'Message',
    addedEP: '105',
    section: 'PreTrade',
    added: 'FIX.5.0SP2',
    name: 'PartiesReferenceData',
  },
  {
    FIXMLFileName: 'accountreporting',
    includeFile: 'components',
    componentType: 'Message',
    addedEP: '117',
    section: 'PostTrade',
    added: 'FIX.5.0SP2',
    name: 'AccountReporting',
    description: 'Account Reporting',
  },
  {
    FIXMLFileName: 'partiesaction',
    includeFile: 'components',
    componentType: 'Message',
    addedEP: '171',
    section: 'PreTrade',
    added: 'FIX.5.0SP2',
    name: 'PartiesAction',
    description:
      'The PartiesAction category of messages is a set of messages that are used to take an action on party information as a result of risk management decisions made during the trading day.',
  },
  {
    FIXMLFileName: 'trademanagement',
    includeFile: 'components',
    componentType: 'Message',
    addedEP: '247',
    section: 'PostTrade',
    added: 'FIX.5.0SP2',
    name: 'TradeManagement',
  },
  {
    FIXMLFileName: 'paymgt',
    includeFile: 'components',
    componentType: 'Message',
    addedEP: '249',
    section: 'PostTrade',
    added: 'FIX.5.0SP2',
    name: 'PayManagement',
    description:
      'Messages used to initiate and confirm expected or future payments to be made or received related to servicing of contracts or transactions after trade settlement. These messages are not intended to instruct or initiate remittance of funds transfers with banks.',
  },
  {
    FIXMLFileName: 'settlstatmgmt',
    includeFile: 'components',
    componentType: 'Message',
    addedEP: '281',
    section: 'PostTrade',
    added: 'FIX.Latest',
    name: 'SettlementStatusManagement',
    description:
      'Messages used to request for or communicate securities settlement status once the settlement process has been initiated via existing industry norms. These messages are not intended to instruct or initiate securities settlement process.',
  },
  {
    FIXMLFileName: 'testing',
    includeFile: 'components',
    componentType: 'Message',
    addedEP: '292',
    section: 'PreTrade',
    added: 'FIX.Latest',
    name: 'Testing',
    description:
      'Messages used to request for or communicate information related to testing, e.g. algorithmic trading and related testing.',
  },
];
